module.exports = __webpack_public_path__ + "static/media/console.a5c8e9cb.svg";